import { twMerge } from "tailwind-merge"
import CheckedIcon from "components/Elements/Icons/Checked"

type CheckBoxBikeFleetProps = {
	id:string, onChange:React.ChangeEventHandler<HTMLInputElement>, checked:boolean, className:string, isSelectable:boolean
}

export const CheckBoxBikeFleet : React.FC<CheckBoxBikeFleetProps> = ({ id, onChange, checked, className, isSelectable = true }) => {
	return (
		<div
			data-cy={`check-${id}`}
			className={twMerge(
				"inline-flex items-center",
				!isSelectable ? "cursor-not-allowed" : "cursor-pointer"
			)}
		>
			<label
				className={twMerge(
					"relative flex items-center p-3 rounded-full",
					!isSelectable ? "pointer-events-none" : "pointer-events-auto"
				)}
				htmlFor={id}
				data-ripple-dark="true"
			>
				<input
					data-cy={`input-check-${id}`}
					onChange={onChange}
					type="checkbox"
					className={twMerge(
						"before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all",
						"before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12",
						"before:-translate-y-2/4 before:-translate-x-2/4",
						"before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity",
						"checked:border-[var(--primaryColor)] checked:bg-[var(--primaryColor)] checked:before:bg-[var(--primaryColor)]",
						"hover:before:opacity-10",
						className
					)}
					id={id}
					checked={checked}
				/>
				<div
					className={twMerge(
						"absolute text-white transition-opacity opacity-0",
						"pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4",
						"peer-checked:opacity-100"
					)}
				>
					<CheckedIcon />
				</div>
			</label>
		</div>
	)
}
